import React, { useState } from "react";

import { useNavigate, useLocation } from "react-router-dom";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';

// core components
import Grid from "@mui/material/Grid";

import { } from "../othelloConstantes.jsx";
import OthelloEdit from "../componentsothello/OthelloEdit.jsx";
import OthelloTimer from "../componentsothello/OthelloTimer.jsx";

import { Helmet } from 'react-helmet'
import OthelloPrimary from "../componentsothello/OthelloPrimary.jsx";
import MDBox from "../components/MDBox/index.js";

import { EstadoReserva } from "../othelloConstantes.jsx";

export default function TicketReserva({ ...props }) {
    const { } = props;

    //ejemplo url
    //https://reservas.ovtspain.es/ticket/reserva?id={Id_Oficina}-{Localizador}&data={dataencodedbase64}"

    const navigate = useNavigate();

    const { search } = useLocation();

    const [loading, setLoading] = React.useState(true);

    const [idofi, setidofi] = React.useState(-1);
    const [localizador, setlocalizador] = React.useState(-1);
    const [data, setdata] = React.useState(null);
    const [ticket, setticket] = React.useState(null);   

    React.useEffect(() => {

        let url = search;
        let params = new URLSearchParams(url);

        let identificador = params.get('id');
        let dt = params.get('data');        

        let idsplit = identificador.split('-');

        setidofi(idsplit[0]);
        setlocalizador(idsplit[1]);      

        setdata(dt);
        
        getDataPage(idsplit[0], idsplit[1], dt);
    }, [loading]);

    const getDataPage = (idofi, locali, data) => {
        if (idofi != null && data != null && locali != null)
        {
            var jsonData = JSON.stringify({ idofi: idofi, localizador: locali, data: data });
        
            fetch('api/Data/GetReservaTicket', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                if (res != null) {
                    setticket(res);
                    setLoading(false);
                }
                else {
                    setticket({ id_ticket: -1 });
                    setLoading(false);
                }
            }).catch(error => {
                setticket({ id_ticket: -1 });
                setLoading(false);
            });
        }
    }

    function renderTicketReserva(item) {

        if (item != null)
        {
            if (item != null) {

                let extras = "";

                if (item.dataExtrasResult != null && item.dataExtrasResult.length > 0) {
                    let resextras = item.dataExtrasResult.map(x =>
                        <Grid container>
                            {x.concepto != null && x.concepto != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="Extra" currentvalue={x.concepto} readonly={true} />
                                </Grid> : ""
                            }
                            {x.precio != null && x.precio != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="Precio" currentvalue={x.precio} readonly={true} />
                                </Grid> : ""
                            }
                        </Grid>
                    );

                    if (resextras != null && resextras != "") {
                        extras = (<><Grid container>
                            <Grid item xs={12} >
                                <OthelloPrimary><h4><b>Extras</b></h4></OthelloPrimary>
                            </Grid>
                        </Grid>
                            {resextras}
                        </>);
                    }
                }

                let nomiacion = "";

                if (item.dataNominacionResult != null && item.dataNominacionResult.length > 0) {
                    let resnomiacion = item.dataNominacionResult.map(x =>
                        <Grid container>
                            {x.nombre != null && x.nombre != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="Nombre" currentvalue={x.nombre} readonly={true} />
                                </Grid> : ""
                            }
                            {x.apellidos != null && x.apellidos != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="Apellidos" currentvalue={x.apellidos} readonly={true} />
                                </Grid> : ""
                            }
                            {x.dni != null && x.dni != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="D. Identidad" currentvalue={x.dni} readonly={true} />
                                </Grid> : ""
                            }
                            {x.sexo != null && x.sexo != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="Sexo" currentvalue={x.sexo} readonly={true} />
                                </Grid> : ""
                            }
                            {x.edad != null && x.edad != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="Edad" currentvalue={x.edad} readonly={true} />
                                </Grid> : ""
                            }
                            {x.fechaNacimiento != null && x.fechaNacimiento != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloTimer label="Fecha de Nacimiento" currentvalue={x.fechaNacimiento} readonly={true} />
                                </Grid> : ""
                            }
                            {x.telefono != null && x.telefono != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="Telefono" currentvalue={x.telefono} readonly={true} />
                                </Grid> : ""
                            }
                            {x.email != null && x.email != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="Email" currentvalue={x.email} readonly={true} />
                                </Grid> : ""
                            }
                            {x.club != null && x.club != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="Club" currentvalue={x.club} readonly={true} />
                                </Grid> : ""
                            }
                            {x.direccion != null && x.direccion != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit label="Direccion" currentvalue={x.direccion} readonly={true} />
                                </Grid> : ""
                            }
                            {x.codigoPostal != null && x.codigoPostal != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="Codigo Postal" currentvalue={x.codigoPostal} readonly={true} />
                                </Grid> : ""
                            }
                            {x.procedencia != null && x.procedencia != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit label="Procedencia" currentvalue={x.procedencia} readonly={true} />
                                </Grid> : ""
                            }
                            {x.talla != null && x.talla != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit label="Talla" currentvalue={x.talla} readonly={true} />
                                </Grid> : ""
                            }
                            {x.numRegistroSanitario != null && x.numRegistroSanitario != "" ?
                                <Grid item xs={6} sm={4} >
                                    <OthelloEdit label="N Registro Sanitario" currentvalue={x.numRegistroSanitario} readonly={true} />
                                </Grid> : ""
                            }
                            {x.curso != null && x.curso != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit label="Curso" currentvalue={x.curso} readonly={true} />
                                </Grid> : ""
                            }
                            {x.madrugadores != null && x.madrugadores != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit label="Madrugadores" currentvalue={x.madrugadores} readonly={true} />
                                </Grid> : ""
                            }
                            {x.sabeNadar != null && x.sabeNadar != "" ?
                                <Grid item xs={6} sm={4}>
                                    <OthelloEdit label="SabeNadar" currentvalue={x.sabeNadar} readonly={true} />
                                </Grid> : ""
                            }
                        </Grid>
                    );

                    if (resnomiacion != null && resnomiacion != "") {
                        nomiacion = (<><Grid container>
                            <Grid item xs={12} >
                                <OthelloPrimary><h4><b>Datos del Formulario</b></h4></OthelloPrimary>
                            </Grid>
                        </Grid>
                            {resnomiacion}
                        </>);
                    }
                }

                let autorizacion = "";

                if (item.dataAutorizacionesDataResult != null) {
                    let respaxnomiacion = "";
                    let resautorizacion = <Grid container>
                        <Grid item xs={6}  >
                            <OthelloEdit label="D/Dna" currentvalue={item.dataAutorizacionesDataResult.nombreApellidosAutoriza} readonly={true} />
                        </Grid>
                        <Grid item xs={6} >
                            <OthelloEdit label="con Documento" currentvalue={item.dataAutorizacionesDataResult.dniAutoriza} readonly={true} />
                        </Grid>
                        <Grid item xs={6} >
                            <OthelloEdit label="Telefono/s" currentvalue={item.dataAutorizacionesDataResult.telefonoAutoriza} readonly={true} />
                        </Grid>
                        <Grid item xs={6} >
                            <OthelloEdit label="AUTORIZO como: " currentvalue={item.dataAutorizacionesDataResult.autorizoComo} readonly={true} />
                        </Grid>
                    </Grid>

                    if (item.dataAutorizacionesDataResult != null && item.dataAutorizacionesDataResult.paxautorizadas != null && item.dataAutorizacionesDataResult.paxautorizadas.length > 0) {
                        respaxnomiacion = item.dataAutorizacionesDataResult.paxautorizadas.map(x =>
                            <Grid container>
                                {x.nombreApellidos != null && x.nombreApellidos != "" ?
                                    <Grid item xs={6}>
                                        <OthelloEdit label="Nombre" currentvalue={x.nombreApellidos} readonly={true} />
                                    </Grid> : ""
                                }
                                {x.dni != null && x.dni != "" ?
                                    <Grid item xs={6}>
                                        <OthelloEdit label="D. Identidad" currentvalue={x.dni} readonly={true} />
                                    </Grid> : ""
                                }
                            </Grid>
                        );
                    }

                    if (resautorizacion != null && resautorizacion != "") {
                        autorizacion = (<><Grid container>
                            <Grid item xs={12} >
                                <OthelloPrimary><h4><b>Datos de Autorizaciones</b></h4></OthelloPrimary>
                            </Grid>
                        </Grid>
                            {resautorizacion}
                            {respaxnomiacion}
                        </>);
                    }
                }

                let informacioncerraduras = "";

                if ((item.activaCerradura == 1 && item.iD_Cerradura != null && item.iD_Cerradura != "") ||
                    (item.idReservCerradura != null && item.idReservCerradura != "") || (item.linkCerradura != null && item.linkCerradura != "") || (item.codigoCerradura != null && item.codigoCerradura != "")) {
                    informacioncerraduras = <> <Grid container>
                        <Grid item xs={12} >
                            <OthelloPrimary><h4><b>Datos de Acceso</b></h4></OthelloPrimary>
                        </Grid>
                    </Grid>
                        <Grid container>
                            <Grid item xs={6} >
                                <OthelloEdit label="ID Acceso" currentvalue={item.idReservCerradura} readonly={true} />
                            </Grid>
                            <Grid item xs={6} >
                                <OthelloEdit label="Codigo Acceso" currentvalue={item.codigoCerradura} readonly={true} />
                            </Grid>
                            <Grid item xs={12} >
                                <OthelloEdit label="Link Acceso" currentvalue={item.linkCerradura} readonly={true} rows={5} />
                            </Grid>
                        </Grid></>
                }

                let informacionuso = "";

                if (ticket != null && ticket.infouso != null && ticket.infouso != "")
                {
                    // infoshow = infoshow.split("\n").map((i, key) => { return <div key={key}>{i}</div>; }); 
                    let infoshow = ticket.infouso.replace("\n", "<br>")

                    infoshow = <div dangerouslySetInnerHTML={{ __html: infoshow }} />;

                    informacionuso = <><br/><hr /><Grid container><Grid item xs={12} mt={4} ml={0}><p style={{ fontSize: 14 }} ><b><center>{infoshow}</center></b></p></Grid></Grid></>;
                }                             

                return (<MDBox m={5}><OthelloPrimary><h4><b>Resumen Reserva</b></h4></OthelloPrimary>
                    <Grid container>
                        <Grid item xs={6}  >
                            <OthelloEdit label="Reserva" currentvalue={item.localizador} readonly={true} />
                        </Grid>
                        <Grid item xs={6}  >
                            <OthelloEdit label="Actividad" currentvalue={item.instalacion} readonly={true} />
                        </Grid>
                        <Grid item xs={6}  >
                            <OthelloEdit label="Fecha" currentvalue={item.fechastring} readonly={true} />
                        </Grid>
                        <Grid item xs={6}  >
                            <OthelloEdit label="Franja" currentvalue={item.tramo} readonly={true} />
                        </Grid>
                        <Grid item xs={6}  >
                            <OthelloEdit label="Plazas" currentvalue={item.cantidad} readonly={true} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6}  >
                            <OthelloEdit label="Alta Reserva" currentvalue={item.fechareservastring} readonly={true} />
                        </Grid>
                        <Grid item xs={6}  >
                            <OthelloEdit label="Estado Reserva" currentvalue={item.estado == EstadoReserva.Confirmada || item.estado == "Confirmada" ? "Confirmada" : "Anulada"} readonly={true} />
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={12}  >
                            <OthelloEdit label="Indicaciones o comentarios" currentvalue={item.observaciones} rows={2} readonly={true} />
                        </Grid>
                    </Grid>
                    {item.precio > 0 ?
                        <>
                            <Grid container>
                                <Grid item xs={12} >
                                    <OthelloPrimary><h4><b>Precio Reserva</b></h4></OthelloPrimary>
                                    <p style={{ color: "#eb4034" }}><h5><b>{item.precio} Euros - {item.pagada == "No" || item.pagado == 0 ? "A Falta de Pago" : "Pagada"}</b></h5> </p>
                                    <p style={{}}><b>Las reservas sin pagar seran canceladas automaticamente en el caso de no realizarse el pago.</b></p>
                                </Grid>
                            </Grid>
                            <Grid>
                                <Grid item xs={12}  >
                                    <OthelloEdit label="Informacion Adicional" currentvalue={item.infoAdicionalPlazasPrecios} rows={2} readonly={true} />
                                </Grid>
                            </Grid></> : ""
                    }
                    <Grid container>
                        <Grid item xs={12} >
                            <OthelloPrimary><h4><b>Datos de Contacto</b></h4></OthelloPrimary>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={6} >
                            <OthelloEdit label="Contacto" currentvalue={item.contacto} readonly={true} />
                        </Grid>
                        <Grid item xs={6} >
                            <OthelloEdit label="E-Mail" currentvalue={item.eMail} readonly={true} />
                        </Grid>
                        <Grid item xs={6} >
                            <OthelloEdit label="Telefono" currentvalue={item.telefono} readonly={true} />
                        </Grid>
                        <Grid item xs={6} >
                            <OthelloEdit label="Dato Adicional" currentvalue={item.numSocio} readonly={true} />
                        </Grid>
                    </Grid>
                    {informacioncerraduras}
                    {extras}
                    {nomiacion}
                    {autorizacion}
                    {informacionuso }
                </MDBox>);
            }
        }
        else
            return <p>No se pudo mostrar el ticket, intentelo mas tarde</p>
    }   

    let cargando = loading ? <p><CircularProgress color="secondary" /></p> : "";       

    return (
        <div>
            <Helmet>
                <title>{!loading ? ticket.nombreoficinashow : "Ticket"}</title>
            </Helmet>            
            {!loading && ticket != null && ticket.imagebannerreservas != null && ticket.imagebannerreservas != "" ?
                <Grid container>
                    <Grid item xs={12}><div
                        style={{ width: '100%', height: 150, border: '0.5px solid', borderColor: '#eeeeee', backgroundColor: '#efefef', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', marginBottom: 10, backgroundImage: "url(" + ticket.imagebannerreservas + ")" }}
                    />
                    </Grid>
                </Grid> : ""
            }
            <MDBox mt={5}>
                <center><h1>{!loading ? ticket.nombreoficinashow : ""}</h1></center>
            </MDBox>
            {loading ? cargando : renderTicketReserva(ticket.reserva)}
        </div>
    );
}
